import { EMPTY_CELL } from '@/shared/constants'

/**
 * A count worded the way a table cell should read it: `1 spot`, `4 spots`, `—` for none.
 *
 * The plural is the singular plus `s` unless the caller gives its own. Zero draws the
 * empty-cell dash rather than `0`, so pass the count straight from the record.
 */
export function countLabel(
  count: number | null | undefined,
  singular: string,
  plural = `${singular}s`
) {
  if (!count) return EMPTY_CELL

  return `${count} ${count === 1 ? singular : plural}`
}
